interface UserFiltersProps {
  search: string;
  statusFilter: string;
  kycFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onKycChange: (value: string) => void;
  onReset: () => void;
}

const selectStyle = {
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat" as const,
  backgroundPosition: "right 0.75rem center",
};

export function UserFilters({
  search,
  statusFilter,
  kycFilter,
  onSearchChange,
  onStatusChange,
  onKycChange,
  onReset,
}: UserFiltersProps) {
  const statuses = [
    {value: "all", label: "Todos"},
    {value: "active", label: "Activo"},
    {value: "suspended", label: "Suspendido"},
    {value: "blocked", label: "Bloqueado"},
  ];

  const kycStatuses = [
    {value: "all", label: "Todos"},
    {value: "approved", label: "Aprobado"},
    {value: "pending", label: "Pendiente"},
    {value: "in_progress", label: "En proceso"},
    {value: "rejected", label: "Rechazado"},
    {value: "failed", label: "Fallido"},
  ];

  const hasActiveFilters = statusFilter !== "all" || kycFilter !== "all" || search.trim() !== "";

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:flex-wrap">
      {/* Search */}
      <div className="relative flex-1 min-w-50">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-4 w-4 text-(--color-text-tertiary)"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
            />
          </svg>
        </div>
        <input
          type="search"
          placeholder="Buscar por nombre o email..."
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          className="w-full pl-9 pr-3 py-2 text-sm bg-(--color-surface) border border-(--color-border) rounded-lg text-(--color-text-primary) placeholder:text-(--color-text-tertiary) focus:outline-none focus:border-(--color-primary) transition-colors"
        />
      </div>

      {/* Status Filter */}
      <select
        value={statusFilter}
        onChange={e => onStatusChange(e.target.value)}
        className="py-2 pl-3 pr-8 text-sm bg-(--color-surface) border border-(--color-border) rounded-lg text-(--color-text-primary) focus:outline-none focus:border-(--color-primary) cursor-pointer transition-colors appearance-none"
        style={selectStyle}
      >
        {statuses.map(s => (
          <option
            key={s.value}
            value={s.value}
          >
            {s.label}
          </option>
        ))}
      </select>

      {/* KYC Filter */}
      <select
        value={kycFilter}
        onChange={e => onKycChange(e.target.value)}
        className="py-2 pl-3 pr-8 text-sm bg-(--color-surface) border border-(--color-border) rounded-lg text-(--color-text-primary) focus:outline-none focus:border-(--color-primary) cursor-pointer transition-colors appearance-none"
        style={selectStyle}
      >
        {kycStatuses.map(s => (
          <option
            key={s.value}
            value={s.value}
          >
            {s.label}
          </option>
        ))}
      </select>

      {/* Reset */}
      {hasActiveFilters && (
        <button
          type="button"
          onClick={onReset}
          className="py-2 px-3 text-sm text-(--color-text-secondary) hover:text-(--color-text-primary) border border-(--color-border) rounded-lg hover:bg-(--color-surface-hover) transition-colors"
        >
          Limpiar
        </button>
      )}
    </div>
  );
}
